export const REDIRECT_ERROR_URL_WRONG_ID = 'The Id in the URL is wrong.';
